import React, { Component } from 'react';
import {connect} from "react-redux";

import {lang} from "../config/lang";
/****************************************
    NoData Component
    @author  IMH003
    @date    2020.05.22
    @version 0.1    
 ******************************************/

class NoData extends Component {

    render() {

        return (
            <div className="row justify-content-center no-data no-data">
                <div className="d-flex-flex">
                    <div className="icon icon-not_interested"></div>
                    <div className="text">{lang('no_data')} ...</div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(NoData);